import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import { Checkbox } from '../ui/checkbox';

export const TicketField = ({ name, label, value, onChange, multiline, type = 'text', disabled, ...rest }) => (
  <div className={`min-w-0 space-y-1.5 ${multiline ? 'sm:col-span-2' : ''}`}>
    <Label htmlFor={name}>{label}</Label>
    {multiline ? <Textarea id={name} data-testid={name.replace(/_/g, '-')} value={value || ''} onChange={(e) => onChange(e.target.value)} disabled={disabled} rows={4} maxLength={12000} {...rest} />
      : <Input id={name} data-testid={name.replace(/_/g, '-')} type={type} value={value ?? ''} onChange={(e) => onChange(e.target.value)} disabled={disabled} className="min-w-0" {...rest} />}
  </div>
);

export const TicketCheck = ({ name, label, value, onChange, disabled }) => (
  <div className="flex min-w-0 items-start gap-2 py-1">
    <Checkbox id={name} data-testid={name.replace(/_/g, '-')} checked={!!value} onCheckedChange={(v) => onChange(v === true)} disabled={disabled} className="mt-0.5 shrink-0" />
    <Label htmlFor={name} className="leading-5 cursor-pointer">{label}</Label>
  </div>
);

export const TicketSection = ({ id, title, children, actions }) => (
  <section className="min-w-0 border-t border-slate-200 pt-6 pb-2" data-testid={`ticket-section-${id.replace(/_/g, '-')}`}>
    <div className="mb-5 flex flex-wrap items-center justify-between gap-3"><h2 className="text-base md:text-lg font-bold text-slate-900">{title}</h2>{actions}</div>
    {children}
  </section>
);

export const TicketFields = ({ prefix, fields, values = {}, onChange, disabled }) => (
  <div className="grid min-w-0 grid-cols-1 sm:grid-cols-2 gap-4">
    {fields.map((f) => <TicketField key={f.key} name={`${prefix}-${f.key}`} label={f.label} multiline={f.multiline}
      value={values[f.key]} onChange={(v) => onChange({ ...values, [f.key]: v })} disabled={disabled || f.readOnly} type={f.key.endsWith('_email') ? 'email' : 'text'} />)}
  </div>
);

export const TicketStatus = ({ status, id }) => {
  const colors = { draft: 'bg-slate-100 text-slate-700', submitted: 'bg-amber-100 text-amber-800', approved: 'bg-emerald-100 text-emerald-800', returned: 'bg-rose-100 text-rose-800' };
  return <span data-testid={`ticket-status-${id}`} className={`inline-flex px-2.5 py-1 rounded text-xs font-semibold capitalize ${colors[status]}`}>{status}</span>;
};